export default __webpack_public_path__ + "static/media/agustin2.d835b6bc.png";